module.exports = __webpack_public_path__ + "img/logo_white.edbba07f.png";